import { AbstractControl, ValidationErrors } from "@angular/forms";
import dayjs from "dayjs";

import {
  VALIDATION_PASSED,
  ValidationErrorKey,
} from "../../validators/general-validation.";
import { ControlType, FormFieldInit } from "../base";

import { FormFieldDate } from "./base";

export class FormFieldDateAge extends FormFieldDate {
  override controlType = ControlType.DATE;

  public minAge: number;
  public maxAge: number;

  constructor(init: FormFieldInit<FormFieldDateAge>) {
    super(init);

    this.minAge = init.minAge;
    this.maxAge = init.maxAge;
    this.validators = [
      validateAge(this.minAge, this.maxAge),
      ...(init.validators || []),
    ];
    super.addErrorMessages({
      [ValidationErrorKey.AGE_BELOW_LIMIT]: $localize`Sie müssen mindestens ${init.minAge}:minAge: Jahre alt sein.`,
      [ValidationErrorKey.AGE_ABOVE_LIMIT]: $localize`Das Maximalalter beträgt ${init.maxAge}:maxAge: Jahre.`,
    });
  }
}

const validateAge =
  (minAge: number, maxAge: number) =>
  (control: AbstractControl<Date | null>): ValidationErrors | null => {
    if (control.value === null) {
      return VALIDATION_PASSED;
    }

    const age = getAge(control.value);

    // validate with dayjs
    if (age > maxAge) {
      return { [ValidationErrorKey.AGE_ABOVE_LIMIT]: true };
    }

    if (age < minAge) {
      return { [ValidationErrorKey.AGE_BELOW_LIMIT]: true };
    }

    return VALIDATION_PASSED;
  };

export const getAge = (date: Date) => dayjs().diff(dayjs(date), "year");
